import { createFlexPrimitive } from './createFlexPrimitive.tsx';

const Stack = createFlexPrimitive({
  direction: 'column',
  defaultAlign: 'stretch',
  defaultJustify: 'start',
  defaultWrap: false,
});

Stack.displayName = 'Stack';

export { Stack };
